import React from 'react';
import { TabBox } from "./TabBox";
import { CalendarBox } from "./CalenderBox";
import { MealBox } from "./MealBox"
import "./release.less"
export function Taste() {
    return (
        <>
            <TabBox />
            <div style={{ marginTop: "15px", display: "flex" }} className="taste1">
                <CalendarBox />
                <MealBox />
            </div>
        </>
    );
}


